<smallstack-button [buttonConfiguration]="data()" [clickFn]="followLink()" />
